import {UI} from "../../../stem-core/src/ui/UIBase.js";
import {styleRule, styleRuleInherit} from "../../../stem-core/src/ui/Style.js";

import {registerStyle} from "../../../stem-core/src/ui/style/Theme.js";
import {ThankYouPanelStyle} from "./ThankYouPanel.jsx";
import {Messages} from "../../Messages.js";
import {MerchantButton} from "../../common/MerchantButton.jsx";
import {PoweredByBlink} from "../PoweredByBlink.jsx";
import {authService} from "../../../client/connection/Services.js";
import {DONATE_PAGE_URLS} from "../PanelConstants.js";
import {redirectToMerchantHomepage} from "../../widget/misc/WidgetUtils.js";
import {iFrameMerchantService} from "../../services/IframeMerchantService.js";
import {iFrameUserDataService} from "../../services/IFrameUserDataService.js";


class ThankYouMessageReceivedPanelStyle extends ThankYouPanelStyle {
    @styleRuleInherit
    text = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        marginBottom: 10,
    };

    @styleRule
    message = {
        padding: "12px 18px",
    };

    @styleRuleInherit
    button = {
        marginBottom: 8,
    }
}

@registerStyle(ThankYouMessageReceivedPanelStyle)
export class ThankYouMessageReceivedPanel extends UI.Element {
    render() {
        const {styleSheet} = this;
        const publicationName = iFrameMerchantService.getMerchant().name;
        const merchantUser = iFrameUserDataService.getMerchantUser();

        if (!merchantUser) {
            return [];
        }

        return [
            <div className={styleSheet.title}>{Messages.thankYou}</div>,
            <div className={styleSheet.text}>{Messages.donatePageThankYouMessageReceived}</div>,
            <div className={styleSheet.message}>
                {merchantUser.formResponses?.donationMessage}
            </div>,
            <MerchantButton onClick={redirectToMerchantHomepage} className={styleSheet.button}>
                {Messages.returnToHomepage(publicationName)}
            </MerchantButton>,
            <PoweredByBlink />,
        ]
    }

    onMount() {
        authService.onAuthenticationChange(() => {
            if (this.isInDocument() && !authService.isAuthenticated()) {
                this.options.changeURL(DONATE_PAGE_URLS.donate, true);
            }
        });
    }
}
